import { render, staticRenderFns } from "./Paquetes.vue?vue&type=template&id=c292ce36&scoped=true"
import script from "./Paquetes.vue?vue&type=script&lang=js"
export * from "./Paquetes.vue?vue&type=script&lang=js"
import style0 from "./Paquetes.vue?vue&type=style&index=0&id=c292ce36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c292ce36",
  null
  
)

export default component.exports